import * as signalR from '@microsoft/signalr';
import { injectable } from 'inversify';
import { TrackingElementsStore } from 'stores/TrackingElementsStore';
import { UiStore } from 'stores/UiStore';
import { LogService } from './LogService';

const RETRY_INTERVAL_TIME = 3000;
@injectable()
export default class TaggingSignalRService {
  private connection: signalR.HubConnection;

  private uiStore: UiStore;

  private logService: LogService;

  private errorCount = 0;

  private trackingElementsStore;

  constructor(url: string, uiStore: UiStore, logService: LogService, trackingElementsStore: TrackingElementsStore) {
    this.uiStore = uiStore;
    this.logService = logService;
    this.trackingElementsStore = trackingElementsStore;

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(url)
      .withAutomaticReconnect({
        nextRetryDelayInMilliseconds: (retryContext) => {
          this.errorCount = retryContext.previousRetryCount + 1;
          return RETRY_INTERVAL_TIME;
        },
      } as signalR.IRetryPolicy)
      .configureLogging(signalR.LogLevel.Information)
      .build();

    this.connection.onreconnected(() => {
      logService.logError({
        error: 'Reconnected',
        message: `Connection to TaggingApp reconnected after ${this.errorCount} attempts`,
      });
    });

    this.connection.onreconnecting((error: Error | undefined) => {
      console.warn('Connection to TaggingApp signalR is closed. Reconnecting...');
    });
  }

  public onActiveClientsChanged = () => {
    this.connection.on('ActiveClientsChanged', (controlMessage: number) => {
      this.uiStore.setSessions(controlMessage);
    });
  };

  start = async () => {
    try {
      this.onActiveClientsChanged();
      await this.connection.start();
    } catch (err) {
      console.warn('Exception when connecting to TaggingApp SignalR. Retrying...');
      setTimeout(() => this.start(), 5000);
    }
  };
}
